import React from "react";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-brand">
          <div className="brand-logo">
            <span className="logo-circle">🌿</span>
          </div>
          <h2>बेलपिंपळगाव</h2>
          <p>परंपरा • संस्कृती • प्रगती</p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-links">
          <h3>Quick Links</h3>
          <a href="/">Home</a>
          <a href="/about">About</a>
          <a href="/gallery">Gallery</a>
          <a href="/contact">Contact</a>
          <a href="/notice">Notice</a>
          <a href="/development">Development</a>
        </div>

        {/* SERVICES */}
        <div className="footer-services">
          <h3>Services</h3>
          <a href="/water">पाणीपट्टी</a>
          <a href="/grampanchayat">ग्रामपंचायत</a>
          <a href="/education">शिक्षण</a>
          <a href="/health">आरोग्य</a>
          <a href="/agriculture">शेती</a>
        </div>

        {/* CONTACT */}
        <div className="footer-contact">
          <h3>Contact</h3>
          <p>📍Shrirampur, Maharashtra</p>
          <p>📞 7774912734</p>
          <p>✉️ info@futuret.in</p>

          <div className="footer-social">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              f
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer">
              ins
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer">
              t
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} • All Rights Reserved • Designed by
        The Bright Futuretech Pvt. Ltd.
      </div>
    </footer>
  );
}
